module.exports = __webpack_public_path__ + "img/left2.04900727.png";